import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdminLogin from '../pages/admin/AdminLogin';
import AdminDashboard from '../pages/admin/AdminDashboard';
import FilmUpload from '../pages/admin/FilmUpload';
import FilmEdit from '../pages/admin/FilmEdit';
import FilmManagement from '../pages/admin/FilmManagement';
import PrivateRoute from '../components/admin/PrivateRoute';

const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<AdminLogin />} />
      <Route 
        path="/" 
        element={
          <PrivateRoute>
            <AdminDashboard />
          </PrivateRoute>
        } 
      />
      <Route 
        path="/films" 
        element={
          <PrivateRoute>
            <FilmManagement />
          </PrivateRoute>
        } 
      />
      <Route 
        path="/upload" 
        element={
          <PrivateRoute>
            <FilmUpload />
          </PrivateRoute>
        } 
      />
      <Route 
        path="/films/edit/:id" 
        element={
          <PrivateRoute>
            <FilmEdit />
          </PrivateRoute>
        } 
      />
      <Route path="*" element={<Navigate to="/admin" replace />} />
    </Routes>
  );
};

export default AdminRoutes;